/** Ant Design Tag colors for container statuses (matches admin containers). */
const CONTAINER_STATUS_COLORS: Record<string, string> = {
  planned: "blue",
  departed: "processing",
  arrived: "success",
  customs: "warning",
  delivered: "success",
  completed: "success",
  cancelled: "error",
};

export const getContainerStatusColor = (status: string | null | undefined): string =>
  CONTAINER_STATUS_COLORS[(status || "").toLowerCase()] || "default";

export const formatContainerStatusLabel = (
  status: string | null | undefined
): string => {
  if (!status) return "-";
  return status.charAt(0).toUpperCase() + status.slice(1);
};
